import { MetricGroup } from 'types'

export function getAllMetricsFromGroups(metricGroups: MetricGroup[]): Record<string, string | number>[] {
  const allMetrics: Record<string, string | number>[] = []
  metricGroups?.forEach((metricGroup) => {
    metricGroup.metricList && allMetrics.push(...metricGroup.metricList.absolute, ...metricGroup.metricList.perCapita)
  })
  return allMetrics
}
